import { PiCheckBold, PiFunnel } from 'react-icons/pi';
import clsx from 'clsx';
import * as DropdownMenu from '@ewf/components/DropdownMenu';

export type FilterBy = {
  unAuditedPools: boolean;
  expiredPools: boolean;
};

export const FilterBy = ({ filterBy, onValueChanged }: Props): JSX.Element => {
  const filterOptions: { id: keyof FilterBy; name: string }[] = [
    {
      id: 'unAuditedPools',
      name: 'Un-audited pools',
    },
    {
      id: 'expiredPools',
      name: 'Expired pools',
    },
  ];

  const toggleFilter = (filter: keyof typeof filterBy) => {
    const newFilters = {
      ...filterBy,
      [filter]: !filterBy[filter],
    };

    onValueChanged(newFilters);
  };

  const handleKeyDown = (event: React.KeyboardEvent, filter: keyof typeof filterBy) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      toggleFilter(filter);
    }
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="gap-0 !pl-3">
        <PiFunnel size={16} className="fill-gray-30" />
        <span className="mr-2">Type</span>
        <DropdownMenu.TriggerIcon />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content sideOffset={5} align="start">
          <DropdownMenu.Label className="mb-1 pl-2 font-primary-light text-sm uppercase tracking-wide text-font-subtle">
            Show
          </DropdownMenu.Label>
          {filterOptions.map((option) => (
            <DropdownMenu.Item
              key={option.id}
              className="flex items-center justify-between gap-2"
              onClick={() => toggleFilter(option.id)}
              onKeyDown={(e) => handleKeyDown(e, option.id)}
              onSelect={(e) => {
                e.preventDefault();
                toggleFilter(option.id);
              }}
            >
              <span>{option.name}</span>
              <div className="flex-none rounded-sm border-gray-50">
                <PiCheckBold
                  size={16}
                  className={clsx({
                    'flex-none fill-brand': true,
                    'opacity-0': !filterBy[option.id],
                  })}
                />
              </div>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

interface Props {
  filterBy: FilterBy;
  onValueChanged: (filterBy: FilterBy) => void;
}
